<script>
import { required, minLength, maxLength, requiredIf } from "vuelidate/lib/validators";
import organizationtype from "../../../helpers/list/organizationtype.json";
import city from "../../../helpers/list/city";

export default {
  components: {},
  props: {},
  data() {
    return {
      // معلومات رئيس المنظمة
      name1: "",
      name2: "",
      name3: "",
      name4: "",
      family_name: "",
      phone: "",
      city_id: "",
      district: "",
      facebook: "",
      instagram: "",

      // معلومات المنظمة او الفريق
      team_name1: "",
      team_name2: "",
      team_name3: "",
      team_name_eng1: "",
      team_name_eng2: "",
      team_name_eng3: "",
      team_phone: "",
      team_gmail: "",
      team_organizationtype_id: "",
      team_other_org: "",
      team_facebook: "",
      team_instagram: "",

      //lists
      list_city: city,
      list_organizationtype: organizationtype,
    };
  },
  validations: {
    // معلومات رئيس المنظمة
    name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name4: { required, minLength: minLength(2), maxLength: maxLength(15) },
    family_name: { required, minLength: minLength(2), maxLength: maxLength(15) },
    phone: { required, minLength: minLength(11), maxLength: maxLength(11) },
    city_id: { required },
    district: { required, minLength: minLength(2), maxLength: maxLength(50) },
    facebook: { minLength: minLength(2), maxLength: maxLength(250) },
    instagram: { minLength: minLength(2), maxLength: maxLength(250) },

    // معلومات المنظمة او الفريق
    team_name1: { required, minLength: minLength(2), maxLength: maxLength(50) },
    team_name2: { required, minLength: minLength(2), maxLength: maxLength(50) },
    team_name3: { required, minLength: minLength(2), maxLength: maxLength(50) },
    team_name_eng1: { required, minLength: minLength(2), maxLength: maxLength(50) },
    team_name_eng2: { required, minLength: minLength(2), maxLength: maxLength(50) },
    team_name_eng3: { required, minLength: minLength(2), maxLength: maxLength(50) },
    team_phone: { required, minLength: minLength(11), maxLength: maxLength(11) },
    team_gmail: { minLength: minLength(2), maxLength: maxLength(100) },
    team_organizationtype_id: { required },
    team_other_org: {
      required: requiredIf(function () {
        return this.getOrgType();
      }),
      minLength: minLength(2),
      maxLength: maxLength(50),
    },
    team_facebook: { minLength: minLength(2), maxLength: maxLength(250) },
    team_instagram: { minLength: minLength(2), maxLength: maxLength(250) },

    form: [
      "name1",
      "name2",
      "name3",
      "name4",
      "family_name",
      "phone",
      "city_id",
      "district",
      "facebook",
      "instagram",
      "team_name1",
      "team_name2",
      "team_name3",
      "team_name_eng1",
      "team_name_eng2",
      "team_name_eng3",
      "team_phone",
      "team_gmail",
      "team_organizationtype_id",
      "team_other_org",
      "team_facebook",
      "team_instagram",
    ],
  },
  methods: {
    // validate
    validate() {
      // alert(this.$v);
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    EnLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z-]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },

    // getOrgType
    getOrgType() {
      return this.team_organizationtype_id == "21";
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات رئيس المنظمة او الفريق</h5></div>

      <div class="col-md-12">
        <div class="row">
          <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
            <b-form-input
              id="name1"
              type="text"
              placeholder="ادخل الاسم"
              v-model="name1"
              :class="{ 'is-invalid': $v.name1.$error }"
            ></b-form-input>
            <div v-if="$v.name1.$error" class="invalid-feedback">
              <span v-if="!$v.name1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name1.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name1.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
            <b-form-input
              id="name2"
              type="text"
              placeholder="ادخل اسم الاب"
              v-model="name2"
              :class="{ 'is-invalid': $v.name2.$error }"
            ></b-form-input>
            <div v-if="$v.name2.$error" class="invalid-feedback">
              <span v-if="!$v.name2.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name2.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name2.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
            <b-form-input
              id="name3"
              type="text"
              placeholder="ادخل اسم الجد"
              v-model="name3"
              :class="{ 'is-invalid': $v.name3.$error }"
            ></b-form-input>
            <div v-if="$v.name3.$error" class="invalid-feedback">
              <span v-if="!$v.name3.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name3.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name3.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
            <b-form-input
              id="name4"
              type="text"
              placeholder="ادخل اسم اب الجد"
              v-model="name4"
              :class="{ 'is-invalid': $v.name4.$error }"
            ></b-form-input>
            <div v-if="$v.name4.$error" class="invalid-feedback">
              <span v-if="!$v.name4.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name4.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name4.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-3 mb-3"
            label=" رقم هاتف رئيس المنظمة : "
            label-for="phone"
          >
            <b-form-input
              id="phone"
              type="number"
              placeholder="ادخل رقم الهاتف"
              v-model="phone"
              :class="{ 'is-invalid': $v.phone.$error }"
            ></b-form-input>
            <div v-if="$v.phone.$error" class="invalid-feedback">
              <span v-if="!$v.phone.required">هذا الحقل الزامي</span>
              <span v-if="!$v.phone.minLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
              >
              <span v-if="!$v.phone.maxLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label=" اللقب : " label-for="family_name">
            <b-form-input
              id="family_name"
              type="text"
              placeholder="ادخل اللقب"
              v-model="family_name"
              :class="{ 'is-invalid': $v.family_name.$error }"
            ></b-form-input>
            <div v-if="$v.family_name.$error" class="invalid-feedback">
              <span v-if="!$v.family_name.required">هذا الحقل الزامي</span>
              <span v-if="!$v.family_name.minLength"
                >يجب أن يتكون اللقب من حرفين على الأقل</span
              >
              <span v-if="!$v.family_name.maxLength"
                >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>

          <b-form-group class="col-md-3 mb-3" label=" المحافظة  : " label-for="city_id">
            <select
              class="form-control form-select"
              id="city_id"
              v-model="city_id"
              :class="{ 'is-invalid': $v.city_id.$error }"
            >
              <option value="">اختر المحافظة</option>
              <option v-for="city in list_city" :value="city.id" :key="city.id">
                {{ city.name }}
              </option>
            </select>
            <div v-if="$v.city_id.$error" class="invalid-feedback">
              <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="القضاء : " label-for="district">
            <b-form-input
              id="district"
              type="text"
              placeholder="ادخل القضاء"
              v-model="district"
              :class="{ 'is-invalid': $v.district.$error }"
            ></b-form-input>
            <div v-if="$v.district.$error" class="invalid-feedback">
              <span v-if="!$v.district.required">هذا الحقل الزامي</span>
              <span v-if="!$v.district.minLength"
                >يجب أن تتكون القضاء من حرفين على الأقل</span
              >
              <span v-if="!$v.district.maxLength"
                >يجب أن تتكون القضاء من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-6 mb-3"
            label="حساب الفيسبوك لرئيس المنظمة  : "
            label-for="facebook"
          >
            <b-form-input
              id="facebook"
              type="text"
              placeholder="ادخل حساب الفيسبوك"
              v-model="facebook"
              :class="{ 'is-invalid': $v.facebook.$error }"
            ></b-form-input>
            <div v-if="$v.facebook.$error" class="invalid-feedback">
              <span v-if="!$v.facebook.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.facebook.maxLength"
                >يجب أن يتكون الحساب من 250 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label="حساب الانستغرام لرئيس المنظمة  : "
            label-for="instagram"
          >
            <b-form-input
              id="instagram"
              type="text"
              placeholder="ادخل حساب الانستغرام"
              v-model="instagram"
              :class="{ 'is-invalid': $v.instagram.$error }"
            ></b-form-input>
            <div v-if="$v.instagram.$error" class="invalid-feedback">
              <span v-if="!$v.instagram.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.instagram.maxLength"
                >يجب أن يتكون الحساب من 250 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <!-- <div class="row"> -->
        <div class="row">
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-4">معلومات المنظمة او الفريق</h5></div>
          <b-form-group
            class="col-md-4 mb-3"
            label="الأسم الاول (الرئيسي ) للمنظمة او الفريق : "
            label-for="team_name1"
          >
            <b-form-input
              id="team_name1"
              type="text"
              placeholder="ادخل الاسم"
              v-model="team_name1"
              :class="{ 'is-invalid': $v.team_name1.$error }"
            ></b-form-input>
            <div v-if="$v.team_name1.$error" class="invalid-feedback">
              <span v-if="!$v.team_name1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.team_name1.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.team_name1.maxLength"
                >يجب أن يتكون الاسم من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label=" الاسم الثاني ( الاحتياط 1 ) للمنظمة او الفريق : "
            label-for="team_name2"
          >
            <b-form-input
              id="team_name2"
              type="text"
              placeholder="ادخل الاسم"
              v-model="team_name2"
              :class="{ 'is-invalid': $v.team_name2.$error }"
            ></b-form-input>
            <div v-if="$v.team_name2.$error" class="invalid-feedback">
              <span v-if="!$v.team_name2.required">هذا الحقل الزامي</span>
              <span v-if="!$v.team_name2.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.team_name2.maxLength"
                >يجب أن يتكون الاسم من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label=" الأسم الثالث ( الاحتياط 2 ) للمنظمة او الفريق :"
            label-for="team_name3"
          >
            <b-form-input
              id="team_name3"
              type="text"
              placeholder="ادخل الاسم"
              v-model="team_name3"
              :class="{ 'is-invalid': $v.team_name3.$error }"
            ></b-form-input>
            <div v-if="$v.team_name3.$error" class="invalid-feedback">
              <span v-if="!$v.team_name3.required">هذا الحقل الزامي</span>
              <span v-if="!$v.team_name3.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.team_name3.maxLength"
                >يجب أن يتكون الاسم من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label="الأسم الاول (الرئيسي ) للمنظمة او الفريق باللغة الانجليزية: "
            label-for="team_name_eng1"
          >
            <b-form-input
              id="team_name_eng1"
              type="text"
              placeholder="الاسم الاول"
              v-model="team_name_eng1"
              v-on:keypress="EnLetter($event)"
              :class="{ 'is-invalid': $v.team_name_eng1.$error }"
            ></b-form-input>
            <div v-if="$v.team_name_eng1.$error" class="invalid-feedback">
              <span v-if="!$v.team_name_eng1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.team_name_eng1.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.team_name_eng1.maxLength"
                >يجب أن يتكون الاسم من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label="الأسم الثاني ( الاحتياط 1 ) للمنظمة او الفريق باللغة الانجليزية :"
            label-for="team_name_eng2"
          >
            <b-form-input
              id="team_name_eng2"
              type="text"
              placeholder="الاسم الثاني"
              v-model="team_name_eng2"
              v-on:keypress="EnLetter($event)"
              :class="{ 'is-invalid': $v.team_name_eng2.$error }"
            ></b-form-input>
            <div v-if="$v.team_name_eng2.$error" class="invalid-feedback">
              <span v-if="!$v.team_name_eng2.required">هذا الحقل الزامي</span>
              <span v-if="!$v.team_name_eng2.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.team_name_eng2.maxLength"
                >يجب أن يتكون الاسم من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label="الأسم الثالث ( الاحتياط 2 ) للمنظمة او الفريق باالغة الانجليزية :"
            label-for="team_name_eng3"
          >
            <b-form-input
              id="team_name_eng3"
              type="text"
              placeholder="الاسم الثالث"
              v-model="team_name_eng3"
              v-on:keypress="EnLetter($event)"
              :class="{ 'is-invalid': $v.team_name_eng3.$error }"
            ></b-form-input>
            <div v-if="$v.team_name_eng3.$error" class="invalid-feedback">
              <span v-if="!$v.team_name_eng3.required">هذا الحقل الزامي</span>
              <span v-if="!$v.team_name_eng3.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.team_name_eng3.maxLength"
                >يجب أن يتكون الاسم من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-12 mb-3"
            label=" اختر نوع المنظمة : "
            label-for="team_organizationtype_id"
          >
            <select
              class="form-control form-select"
              id="team_organizationtype_id"
              v-model="team_organizationtype_id"
              :class="{ 'is-invalid': $v.team_organizationtype_id.$error }"
            >
              <option value="">أختر النوع</option>
              <option
                v-for="organizationtype in list_organizationtype"
                :value="organizationtype.id"
                :key="organizationtype.id"
              >
                {{ organizationtype.name }}
              </option>
            </select>
            <div v-if="$v.team_organizationtype_id.$error" class="invalid-feedback">
              <span v-if="!$v.team_organizationtype_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            v-if="getOrgType()"
            label="نوع منظمة غير مذكور في القائمة : "
            label-for="team_other_org"
          >
            <b-form-input
              id="team_other_org"
              type="text"
              placeholder="ادخل الاسم"
              v-model="team_other_org"
              :class="{ 'is-invalid': $v.team_other_org.$error }"
            ></b-form-input>
            <div v-if="$v.team_other_org.$error" class="invalid-feedback">
              <span v-if="!$v.team_other_org.required">هذا الحقل الزامي</span>
              <span v-if="!$v.team_other_org.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.team_other_org.maxLength"
                >يجب أن يتكون الاسم من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-6 mb-3"
            label="حساب الفيسبوك للمنظمة / الفريق : "
            label-for="team_facebook"
          >
            <b-form-input
              id="team_facebook"
              type="text"
              placeholder="ادخل حساب الفيسبوك"
              v-model="team_facebook"
              :class="{ 'is-invalid': $v.team_facebook.$error }"
            ></b-form-input>
            <div v-if="$v.team_facebook.$error" class="invalid-feedback">
              <span v-if="!$v.team_facebook.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.team_facebook.maxLength"
                >يجب أن يتكون الحساب من 250 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label="حساب الانستغرام للمنظمة / الفريق : "
            label-for="team_instagram"
          >
            <b-form-input
              id="team_instagram"
              type="text"
              placeholder="ادخل حساب الانستغرام"
              v-model="team_instagram"
              :class="{ 'is-invalid': $v.team_instagram.$error }"
            ></b-form-input>
            <div v-if="$v.team_instagram.$error" class="invalid-feedback">
              <span v-if="!$v.team_instagram.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.team_instagram.maxLength"
                >يجب أن يتكون الحساب من 250 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-6 mb-3"
            label="البريد الالكتروني الرسمي للمنظمة / الفريق :"
            label-for="team_gmail"
          >
            <b-form-input
              id="team_gmail"
              type="email"
              placeholder="ادخل البريد الالكتروني "
              v-model="team_gmail"
              :class="{ 'is-invalid': $v.team_gmail.$error }"
            ></b-form-input>
            <div v-if="$v.team_gmail.$error" class="invalid-feedback">
              <span v-if="!$v.team_gmail.minLength"
                >يجب أن يتكون الحساب من حرفين على الأقل</span
              >
              <span v-if="!$v.team_gmail.maxLength"
                >يجب أن يتكون الحساب من 100 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label="الهاتف المخصص للتواصل مع المنظمة / الفريق :"
            label-for="team_phone"
          >
            <b-form-input
              id="team_phone"
              type="number"
              placeholder="ادخل رقم الهاتف"
              v-model="team_phone"
              :class="{ 'is-invalid': $v.team_phone.$error }"
            ></b-form-input>
            <div v-if="$v.team_phone.$error" class="invalid-feedback">
              <span v-if="!$v.team_phone.required">هذا الحقل الزامي</span>
              <span v-if="!$v.team_phone.minLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
              >
              <span v-if="!$v.team_phone.maxLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
